import { Snackbar, useTheme } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import React, { useState, useEffect, useRef } from 'react'
import { usePrescriptionsQuery } from '../queries/usePrescriptionsQuery'
import { useLoading } from '../../../../shared'

export const usePrescriptions = () => {
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false)
  const previousCountRef = useRef(0)

  const { LoadingOverlay, setIsLoading } = useLoading()

  const { data: prescriptions = [], isPending } = usePrescriptionsQuery()

  // ローディング状態の同期
  useEffect(() => {
    setIsLoading(isPending)
  }, [isPending, setIsLoading])

  /**
   * set-state-in-effect の正当性:
   * - これは「派生状態」ではなく「イベント検出」パターン
   * - prescriptions.length の変化を「イベント」として検出し、一時的な UI 通知をトリガー
   * - setIsOpen(true) は prescriptions を変更しないため、カスケードレンダリングは発生しない
   *
   * React ドキュメントでも、イベント検出での useEffect + setState は許容される:
   * 参考: https://react.dev/learn/you-might-not-need-an-effect#sending-a-post-request
   *
   * 代替パターン（useSyncExternalStore）は過剰設計となるため、現状を維持。
   */
  useEffect(() => {
    const currentCount = prescriptions.length
    const previousCount = previousCountRef.current

    // 前回より件数が増えた場合（初回取得時を除く）
    if (currentCount > previousCount && previousCount > 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsOpen(true)
    }

    previousCountRef.current = currentCount
  }, [prescriptions])

  const AdditionalPrescSnackBar = () => (
    <div>
      <Snackbar
        style={{ zIndex: 101, marginRight: '60px' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={isOpen}
        autoHideDuration={3000}
        onClose={() => setIsOpen(false)}
      >
        <MuiAlert
          sx={{ bgcolor: theme.palette.primary.translucent }}
          elevation={6}
          variant="filled"
          onClose={() => setIsOpen(false)}
        >
          新規読み取りが完了しました
        </MuiAlert>
      </Snackbar>
    </div>
  )

  return {
    AdditionalPrescSnackBar,
    prescriptions,
    LoadingOverlay,
  }
}
